import { Flex } from '@chakra-ui/react'
import React from 'react'

export const CallDetailsRow = ({ children }: React.PropsWithChildren) => {
  return (
    <Flex alignItems="center" gap="1.25rem">
      {React.Children.map(children, (child) => (
        <Flex
          data-testid="call-flow-container"
          flexDirection="column"
          py="1rem"
          px="1rem"
          alignItems="flex-start"
          gap="0.625rem"
          alignSelf="stretch"
          borderRadius="0.5rem"
          border="1px solid"
          borderColor="border.default"
          bg="bg.subtle"
          width="full"
        >
          {child}
        </Flex>
      ))}
    </Flex>
  )
}

export const CallDetailsRowItem = ({ children }: React.PropsWithChildren) => {
  return (
    <Flex
      data-testid="call-details-container"
      flexDirection="column"
      alignSelf="stretch"
      alignItems="flex-start"
      gap="0.625rem"
      flex="1 0 0"
    >
      {children}
    </Flex>
  )
}
